// BIRTH-TIME-1: what the Home dasha card should show instead of the current period, read
// from a /api/hierarchical-dasha response. Every date is the engine's; nothing is computed.
//   * a 422 {detail:{code:'invalid_birth_time'}} → {kind:'invalid_time'} ("Birth time looks wrong — edit");
//   * birth_details.birth_in_future → {kind:'future', mahadasha, next}: the Mahadasha running
//     at birth (dasha_hierarchy[0]) and the next 3 (owner ruling, 19 Oct 2026);
//   * anything else → null (the normal "current period" card).
import { isInvalidBirthTimeError } from './birthTime';

export const NEXT_MAHADASHAS = 3;

export function dashaCardStateFrom(ok, data) {
  if (!ok) return isInvalidBirthTimeError(data) ? { kind: 'invalid_time' } : null;
  if (!data || !data.birth_details || data.birth_details.birth_in_future !== true) return null;
  const list = Array.isArray(data.dasha_hierarchy) ? data.dasha_hierarchy : [];
  if (!list.length) return null;
  const pick = (p) => ({ planet: p.planet, start_date: p.start_date, end_date: p.end_date });
  return {
    kind: 'future',
    mahadasha: pick(list[0]),
    next: list.slice(1, 1 + NEXT_MAHADASHAS).map(pick),
  };
}
